/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { NotEqualKeyTypeValue } from './NotEqualKeyTypeValue';

export const NotEqualKeyType: core.serialization.ObjectSchema<
    serializers.NotEqualKeyType.Raw,
    Truvity.NotEqualKeyType
> = core.serialization.object({
    value: NotEqualKeyTypeValue,
});

export declare namespace NotEqualKeyType {
    export interface Raw {
        value: NotEqualKeyTypeValue.Raw;
    }
}
